module.exports = __webpack_public_path__ + "img/9-filters-05.0761ad27.svg";